module.exports = __webpack_public_path__ + "img/dashboard.c96bcc2d.svg";